const cfStack = `<CreateStackResponse xmlns="http://cloudformation.amazonaws.com/doc/2010-05-15/">
  <CreateStackResult>
    <StackId>arn:aws:cloudformation:us-east-1:210811600188:stack/greatagentOCCM1755761222945/3c694ee0-7e60-11f0-b248-12a79ec20847</StackId>
  </CreateStackResult>
  <ResponseMetadata>
    <RequestId>ca42f932-9d4c-4330-8f58-5064765e9254</RequestId>
  </ResponseMetadata>
</CreateStackResponse>`

export default cfStack;
